import { defineMessages } from 'react-intl';

// eslint-disable-next-line formatjs/blocklist-elements
export default defineMessages({
    remainingOutstanding: {
        id: '_.early_repayment.choose_repayment_amount.remaining_outstanding',
        defaultMessage: 'Reducing your balance to'
    },
    unsupported: {
        id: '_.early_repayment.choose_repayment_amount.unsupported',
        defaultMessage:
            'Your repayment schedule will be adjusted to take into account your early repayment.'
    },
    reducedRepaymentText: {
        id: '_.early_repayment.choose_repayment_amount.next_repayment.reduced_repayment_text',
        defaultMessage: '{numberOfNextRepayments} repayments'
    },
    nextReducedRepaymentText: {
        id: '_.early_repayment.choose_repayment_amount.next_repayment.nextReduced_repayment_text',
        defaultMessage:
            '{reducedNextRepayment, selectordinal, one {#st} two {#nd} few {#rd} other {#th}} repayment to {reducedNextRepaymentAmount}'
    },
    normal: {
        id: '_.early_repayment.choose_repayment_amount.next_repayment.normal',
        defaultMessage:
            'This will cover your next {reducedRepaymentText} and reduce your {nextReducedRepaymentText}.'
    },
    partialNextRepayment: {
        id: '_.early_repayment.choose_repayment_amount.next_repayment.partial_next_repayment',
        defaultMessage:
            'This will reduce your next payment to {reducedNextRepaymentAmount}'
    },
    partialTodayNextRepayment: {
        id: '_.early_repayment.choose_repayment_amount.next_repayment.partial_today_next_repayment',
        defaultMessage:
            'This will reduce the amount due today to {reducedNextRepaymentAmount}'
    },
    exactAmount: {
        id: '_.early_repayment.choose_repayment_amount.next_repayment.exact_amount',
        defaultMessage: 'This will cover your next {reducedRepaymentText}.'
    },
    equal: {
        id: '_.early_repayment.choose_repayment_amount.following_repayments.equal',
        defaultMessage:
            'Your following repayments will stay the same at {followingRepaymentAmount} per month.'
    },
    showSchedule: {
        id: '_.early_repayment.choose_repayment_amount.show_schedule',
        defaultMessage: 'See your new schedule in full'
    },
    repaymentsCovered: {
        id: '_.early_repayment.choose_repayment_amount.repayments_covered',
        defaultMessage: 'This will cover all of your repayments'
    },
    noFurtherRepayments: {
        id: '_.early_repayment.choose_repayment_amount.no_further_repayments',
        defaultMessage: 'You have no further repayments after that'
    }
});
